import axios from "axios"

export const postEvent = (space, type, additionalParams = {}) => {
  const { spaceName, shareToken } = space || {}
  axios.post("/api/events", {
    event: {
      type: type,
      space_name: spaceName,
      share_token: shareToken,
      ...additionalParams,
    },
  })
}
